import { ScreenQuestionProps } from './types';

export const EDUCATION_QUESTION_TEXT = 'Have you completed the following level of education?';

const BASE_EDUCATION_SCREEN_QUESTION: ScreenQuestionProps = {
  title: 'Education',
  question: EDUCATION_QUESTION_TEXT,
  type: 'Education',
  category: 'PreDefined',
  answerType: 'YesNo',
};

export const EDUCATION_PREDEFINED_QUESTION: ScreenQuestionProps = {
  ...BASE_EDUCATION_SCREEN_QUESTION,
  required: true,
};

export const createEducationQuestion = (
  overrides: Partial<ScreenQuestionProps> = {},
): ScreenQuestionProps => {
  const next: ScreenQuestionProps = {
    ...BASE_EDUCATION_SCREEN_QUESTION,
    required: false,
    educationLevel: '',
    expectedAnswer: '',
    expectedYesNo: '',
    ...overrides,
  };

  const normalizedLevel = typeof next.educationLevel === 'string' ? next.educationLevel : '';

  const normalizedAnswer =
    typeof next.expectedAnswer === 'string' && next.expectedAnswer.length > 0
      ? next.expectedAnswer
      : typeof next.expectedYesNo === 'string'
      ? next.expectedYesNo
      : '';

  return {
    ...next,
    educationLevel: normalizedLevel,
    expectedAnswer: normalizedAnswer,
    expectedYesNo: normalizedAnswer,
    question: overrides.question ?? EDUCATION_QUESTION_TEXT,
  };
};
